var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import TreeNode from './TreeNode';
import { defaultProps } from './defaults';
import { NewTree } from '@feb-team/data-logic';
import { DropType, modifyClassType } from './TreeUtil';
import { DivTag } from '../../Utils/AtomicTag';
var Tree = /** @class */ (function (_super) {
    __extends(Tree, _super);
    function Tree(props) {
        var _this = _super.call(this, props) || this;
        _this.onDragOver = function (e, orignid) {
            if (_this.props.disabled) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            var id = "" + orignid;
            var currIndexId = "" + _this.curel;
            if (_this.entity.isValidMove(currIndexId, id)) {
                var el = e.target;
                var _a = el.getBoundingClientRect(), top_1 = _a.top, height = _a.height;
                var clientY = e.clientY;
                if (height - (clientY - top_1) < 12) {
                    modifyClassType(el, DropType.BOTTOM);
                    _this.dragtype = DropType.BOTTOM;
                }
                else if (clientY - top_1 < 12) {
                    modifyClassType(el, DropType.TOP);
                    _this.dragtype = DropType.TOP;
                }
                else {
                    modifyClassType(el, DropType.CENTER);
                    _this.dragtype = DropType.CENTER;
                }
                el.classList.add('drag-target');
                var targetNode = _this.entity.getNodes(id)[0];
                if (targetNode && targetNode.expand) {
                    targetNode.expand = false;
                }
            }
        };
        _this.onDragLeave = function (e) {
            if (_this.props.disabled) {
                return;
            }
            e.stopPropagation();
            var el = e.target;
            _this.dragtype = null;
            modifyClassType(el, null);
        };
        _this.onDragStart = function (e, id) {
            if (_this.props.disabled) {
                return false;
            }
            e.stopPropagation();
            _this.curel = id && parseInt(id, 10);
            var node = _this.entity.getNodes(id)[0];
            node.expand = true;
        };
        _this.onDrop = function (e, targetId) {
            if (_this.props.disabled) {
                return;
            }
            e.stopPropagation();
            var nTargetId = targetId;
            var _a = _this, dragtype = _a.dragtype, currIndexId = _a.curel;
            if (_this.entity.isValidMove("" + currIndexId, "" + nTargetId)) {
                if (dragtype === DropType.CENTER) {
                    _this.entity.append(currIndexId, nTargetId);
                }
                else if (dragtype === DropType.TOP) {
                    _this.entity.insertBefore(currIndexId, nTargetId);
                }
                else {
                    _this.entity.insertAfter(currIndexId, nTargetId);
                }
                var el = e.target;
                modifyClassType(el, null);
                _this.setState({
                    tree: _this.entity.DATA,
                });
                _this.props.onDrop(_this.entity.getNodes(currIndexId)[0], _this.entity.getNodes(nTargetId)[0], e);
            }
        };
        _this.toggerExpand = function (e, id) {
            if (_this.props.disabled) {
                return;
            }
            var node = _this.entity.getNodes(id)[0];
            var expanded = typeof node.expanded === 'undefined' ? false : node.expanded;
            node.expanded = !expanded;
            var keysNode = _this.entity.DATA.filter(function (i) { return i.expanded; });
            var setKeys = keysNode.map(function (i) { return i.key; });
            _this.setState({
                expandedKeys: setKeys,
            });
            _this.props.onExpand(setKeys, keysNode, e);
        };
        _this.selectLeaf = function (e, id) {
            if (_this.props.disabled) {
                return false;
            }
            var node = _this.entity.getNodes(id)[0];
            if (!_this.props.multiple) {
                _this.entity.DATA.forEach(function (i) {
                    if (i.id !== id) {
                        i.active = false;
                    }
                    return i;
                });
            }
            var active = typeof node.active === 'undefined' ? false : node.active;
            node.active = !active;
            var keysNode = _this.entity.DATA.filter(function (i) { return i.active; });
            var setKeys = keysNode.map(function (i) { return i.key; });
            _this.setState({
                selectedKeys: setKeys,
            });
            _this.props.onSelect(setKeys, keysNode, e);
        };
        _this.toggerCheckbox = function (e, id) {
            if (_this.props.disabled) {
                return;
            }
            var node = _this.entity.getNodes(id)[0];
            var checkbox = typeof node.checkbox === 'undefined' ? false : node.checkbox;
            _this.setCheckStatus(node, !checkbox);
            var keysNode = _this.entity.DATA.filter(function (i) { return i.checkbox; });
            var halfCheckNode = _this.entity.DATA.filter(function (i) { return i.status === 'semi-checked'; });
            var setKeys = keysNode.map(function (i) { return i.key; });
            _this.setState({
                checkedKeys: setKeys,
            });
            _this.setState({
                tree: _this.entity.DATA,
            });
            _this.props.onCheck(setKeys, keysNode, halfCheckNode, e);
        };
        _this.setCheckedStatus = function (checkedKeys) {
            if (checkedKeys) {
                checkedKeys.forEach(function (key) {
                    var node = _this.entity.getNodes(key, 'key')[0];
                    _this.setCheckStatus(node, true);
                });
            }
        };
        _this.setExpandedStatus = function (expandedKeys) {
            var defaultExpandAll = _this.props.defaultExpandAll;
            if (defaultExpandAll) {
                var setNodes = _this.entity.DATA.filter(function (node) { return !!node.children; });
                if (setNodes) {
                    setNodes.forEach(function (node) {
                        node.expanded = true;
                    });
                }
            }
            else if (expandedKeys) {
                var setNodes = _this.entity.DATA.filter(function (node) { return !!node.children; });
                if (setNodes) {
                    setNodes.forEach(function (node) {
                        node.expanded = false;
                    });
                }
                expandedKeys.forEach(function (key) {
                    var node = _this.entity.getNodes(key, 'key')[0];
                    if (node) {
                        var pNodes = _this.entity.getAncestors(node.id);
                        pNodes.forEach(function (pid) {
                            var pNode = _this.entity.getNodes(pid)[0];
                            if (pNode) {
                                pNode.expanded = true;
                            }
                        });
                        node.expanded = true;
                    }
                });
            }
        };
        _this.setSelectedStatus = function (selectedKeys) {
            if (selectedKeys) {
                selectedKeys.forEach(function (key) {
                    var node = _this.entity.getNodes(key, 'key')[0];
                    if (node) {
                        node.active = true;
                    }
                });
            }
        };
        _this.setCheckStatus = function (node, checked) {
            if (!node) {
                return;
            }
            node.checkbox = checked;
            node.status = '';
            var id = node.id;
            if (id !== undefined && node.children) {
                var childrenNode = _this.entity.getOffspring(id);
                if (childrenNode.length > 0) {
                    childrenNode.forEach(function (innernode) {
                        var currNode = _this.entity.getNodes(innernode)[0];
                        currNode.checkbox = checked;
                        currNode.status = '';
                    });
                }
            }
            if (id !== undefined && node.parentId) {
                var checkIsFull_1 = function (arr, checkType) {
                    var checkedArr = arr.filter(function (id) {
                        return !!_this.entity.getNodes(id)[0].checkbox === checkType;
                    });
                    return checkedArr.length === arr.length;
                };
                var parentNode = _this.entity.getAncestors(id);
                if (parentNode.length > 0) {
                    parentNode.forEach(function (innerid) {
                        var innernode = _this.entity.getNodes(innerid)[0];
                        if (!innernode) {
                            return;
                        }
                        if (!checked) {
                            innernode.checkbox = checked;
                            var eleChildren = _this.entity.getOffspring(innerid);
                            var isEmpty = checkIsFull_1(eleChildren, false);
                            innernode.status = isEmpty ? '' : 'semi-checked';
                        }
                        else {
                            var isFull = checkIsFull_1(innernode.children, true);
                            innernode.checkbox = isFull ? checked : !checked;
                            innernode.status = isFull ? '' : 'semi-checked';
                        }
                    });
                }
            }
        };
        _this.getNodeList = function () {
            var tree = _this.state.tree;
            var _a = _this.props, renderExpand = _a.renderExpand, renderLeaf = _a.renderLeaf, draggable = _a.draggable, disabled = _a.disabled;
            var hasCheck = _this.props.hasCheck || false;
            var currNode = _this.entity.getNodes('0', 'parentId');
            return currNode.map(function (node, index) {
                return (React.createElement(TreeNode, { key: node.key ? node.key : index, id: node.id, entity: _this.entity, tree: tree, toggerExpand: _this.toggerExpand, selectLeaf: _this.selectLeaf, renderExpand: renderExpand, renderLeaf: renderLeaf, onDragLeave: _this.onDragLeave, onDragOver: _this.onDragOver, onDrop: _this.onDrop, onDragStart: _this.onDragStart, draggable: draggable, hasCheck: hasCheck, toggerCheckbox: _this.toggerCheckbox, disabled: disabled }));
            });
        };
        var data = props.data, defaultCheckedKeys = props.defaultCheckedKeys, checkedKeys = props.checkedKeys, defaultExpandedKeys = props.defaultExpandedKeys, expandedKeys = props.expandedKeys, defaultSelectedKeys = props.defaultSelectedKeys, selectedKeys = props.selectedKeys;
        _this.entity = NewTree(data, 'tree');
        var tExpandedKeys = defaultExpandedKeys || expandedKeys || [];
        var tSelectedKeys = defaultSelectedKeys || selectedKeys || [];
        var tCheckedKeys = defaultCheckedKeys || checkedKeys || [];
        _this.state = {
            tree: _this.entity.DATA,
            expandedKeys: tExpandedKeys,
            selectedKeys: tSelectedKeys,
            checkedKeys: tCheckedKeys,
        };
        _this.curel = null;
        _this.dragtype = null;
        _this.setExpandedStatus(tExpandedKeys);
        _this.setSelectedStatus(tSelectedKeys);
        _this.setCheckedStatus(tCheckedKeys);
        return _this;
    }
    Tree.prototype.componentWillReceiveProps = function (nextProps) {
        var newState = {};
        var _a = this.state, tree = _a.tree, expandedKeys = _a.expandedKeys, selectedKeys = _a.selectedKeys, checkedKeys = _a.checkedKeys;
        if ('expandedKeys' in nextProps) {
            newState.expandedKeys = nextProps.expandedKeys;
            this.setExpandedStatus(nextProps.expandedKeys);
        }
        if ('selectedKeys' in nextProps) {
            newState.selectedKeys = nextProps.selectedKeys;
            this.setSelectedStatus(nextProps.selectedKeys);
        }
        if ('checkedKeys' in nextProps) {
            newState.checkedKeys = nextProps.checkedKeys;
            this.setCheckedStatus(nextProps.checkedKeys);
        }
        if (nextProps.data && this.props.data.toString() !== nextProps.data.toString()) {
            this.entity = NewTree(nextProps.data, 'tree');
            newState.tree = this.entity.DATA;
        }
        if (newState.expandedKeys || newState.selectedKeys || newState.checkedKeys || newState.tree) {
            this.setState({
                tree: newState.tree ? newState.tree : tree,
                checkedKeys: newState.checkedKeys ? newState.checkedKeys : checkedKeys,
                selectedKeys: newState.selectedKeys ? newState.selectedKeys : selectedKeys,
                expandedKeys: newState.expandedKeys ? newState.expandedKeys : expandedKeys,
            });
        }
    };
    Tree.prototype.render = function () {
        var _a = this.props, renderExpand = _a.renderExpand, renderLeaf = _a.renderLeaf, data = _a.data, multiple = _a.multiple, defaultExpandAll = _a.defaultExpandAll, hasCheck = _a.hasCheck, draggable = _a.draggable, onCheck = _a.onCheck, onDrop = _a.onDrop, onExpand = _a.onExpand, onSelect = _a.onSelect, defaultCheckedKeys = _a.defaultCheckedKeys, checkedKeys = _a.checkedKeys, defaultExpandedKeys = _a.defaultExpandedKeys, defaultSelectedKeys = _a.defaultSelectedKeys, expandedKeys = _a.expandedKeys, selectedKeys = _a.selectedKeys, disabled = _a.disabled, rest = __rest(_a, ["renderExpand", "renderLeaf", "data", "multiple", "defaultExpandAll", "hasCheck", "draggable", "onCheck", "onDrop", "onExpand", "onSelect", "defaultCheckedKeys", "checkedKeys", "defaultExpandedKeys", "defaultSelectedKeys", "expandedKeys", "selectedKeys", "disabled"]);
        var html = this.getNodeList();
        return (React.createElement(DivTag, __assign({ name: Tree.NAME, atomics: "w-px-220" }, rest), html));
    };
    Tree.defaultProps = defaultProps;
    Tree.NAME = 'tree';
    Tree.displayName = 'Tree';
    return Tree;
}(React.Component));
export { Tree };
